import {
  PayrollConceptSelectorFormFieldDocument,
  PayrollConceptSelectorFormFieldQuery,
  PayrollValueObjectsConceptCategoryEnum,
  PayrollValueObjectsConceptUnitTypeEnum,
} from 'generated/resources/graphql'

import {
  createGraphqlDataSourceDefinition,
  useGraphqlDataSource,
} from 'modules/core/hooks/useGraphqlDataSource'

export type PayrollConceptRecord = {
  id: string
  name: string
  label: string
}

export type UsePayrollConceptSourceParams = {
  categories?: PayrollValueObjectsConceptCategoryEnum[]
  unitTypes?: PayrollValueObjectsConceptUnitTypeEnum[]
  withActiveStatus?: boolean
}

export const usePayrollConceptSource = ({
  categories,
  unitTypes,
  withActiveStatus,
}: UsePayrollConceptSourceParams = {}) => {
  const definition = createGraphqlDataSourceDefinition({
    document: PayrollConceptSelectorFormFieldDocument,
    paginationType: 'infinite-scroll',
    perPage: 20,
    mapVariables: () => {
      return {
        ...(categories ? { categories: [...categories] } : {}),
        ...(unitTypes ? { unitTypes: [...unitTypes] } : {}),
        withActiveStatus,
      }
    },
    mapData: (data: PayrollConceptSelectorFormFieldQuery): PayrollConceptRecord[] =>
      data.payroll?.conceptsConnection?.edges?.map((edge) => ({
        id: edge.node.id,
        name: edge.node.name,
        label: edge.node.label,
      })) ?? [],
    mapPagination: (data: PayrollConceptSelectorFormFieldQuery) => ({
      total: data.payroll?.conceptsConnection?.totalCount ?? 0,
      cursor: data.payroll?.conceptsConnection?.pageInfo?.endCursor ?? undefined,
      hasNextPage: data.payroll?.conceptsConnection?.pageInfo?.hasNextPage ?? false,
    }),
  })

  return useGraphqlDataSource(definition, [categories, unitTypes, withActiveStatus])
}
